import { World } from "ecsy";
import { TimeContext } from "./Context/TimeContext";
import { init } from "./Init";
import { update } from "./Update";

export const timeContext: TimeContext = {
  startTime: 0,
  currTime: 0,
  deltaTime: 0,
};

export const mainWorld = new World();

const coreInit = () => {
  timeContext.startTime = Date.now() / 1000;
  timeContext.currTime = timeContext.startTime;

  init(mainWorld);

  window.requestAnimationFrame(coreUpdate);
};

const coreUpdate = () => {
  const now = Date.now() / 1000;
  timeContext.deltaTime = now - timeContext.currTime;
  timeContext.currTime = now;

  update(mainWorld, timeContext);

  window.requestAnimationFrame(coreUpdate);
};

window.onload = coreInit;
